"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modifyConfig = void 0;
const blocks_1 = require("./types/blocks");
// given a standard format and a sparsely populated set of overrides, create a new config.
// (this is slightly more tricky than a shallow merge because of the dual-dialogue overrides)
const modifyConfig = (base, overrides) => {
    // start by cloning the base
    const result = { ...base };
    // override the individual blocks one at a time if they're present in the override
    blocks_1.UNIFORM_BLOCK_TYPES.forEach((blockType) => {
        const override = overrides[blockType];
        if (override) {
            result[blockType] = { ...result[blockType], ...override };
        }
    });
    // for dual format types, we need to override/merge the dual dialogue config
    blocks_1.DUAL_FORMAT_BLOCK_TYPES.forEach((blockType) => {
        const override = overrides[blockType];
        const base = result[blockType];
        if (override) {
            const dualDialogOverrides = {
                ...base.dualDialogOverrides,
                ...override.dualDialogOverrides,
            };
            result[blockType] = {
                ...base,
                ...override,
                dualDialogOverrides,
            };
        }
    });
    return result;
};
exports.modifyConfig = modifyConfig;
